/* eslint-disable no-console */
import Cookies from 'js-cookie';
import store from '../../shared/Store';
import platformService from '../services/platform.service';
import { defaultStats } from './defaultStats';
import { trackEvent as tcTrackEvent, trackPage as tcTrackPage } from './tagCommanderTracker';
import { generateEvent, getCurrentModal, getCurrentPage, splitPath } from './utils';

export function trackEvent(eventName, payload) {
  // if (process.env.NODE_ENV !== 'production') {
  //   // console.log(`trackEvent ${eventName} - blocked in dev\n`, payload);
  //   return;
  // }

  const currentRgpdRules = store.storage.getRgpdRules();

  if (currentRgpdRules?.status === 'refuse') {
    // console.log(`trackEvent ${eventName} - blocked by rgpd policy`);
    return;
  }

  const isUserConnected = store?.user?._id;
  if (!isUserConnected) return;

  // Future switch on tracker types
  const stats = window.__DATA__?.screens?.stats || {};

  if (defaultStats[eventName] && stats[eventName] !== false) {
    platformService.stats(defaultStats[eventName].tag, {
      ...payload,
      from: window.location.href,
    });
    return;
  }

  if (stats[eventName]) {
    const event = generateEvent(eventName, payload, stats);
    if (event) {
      // Push to server...
      platformService.stats(event.tag, { ...event.payload, from: window.location.href });
    }
  }

  if (window.trackEvent) {
    window.trackEvent(eventName, payload);
  }

  // Future switch on tracker types
  if (window.__DATA__?.tagCommander?.trackEvents) {
    const event = generateEvent(eventName, payload, window.__DATA__.tagCommander.trackEvents);
    if (event) {
      tcTrackEvent(event);
    }
  }
}

export function trackModal(modalConfig, payload) {
  const currentRgpdRules = store.storage.getRgpdRules();

  if (currentRgpdRules?.status === 'refuse') {
    // console.log(`trackModal ${modalConfig} - blocked by rgpd policy`);
    return;
  }
  if (process.env.NODE_ENV !== 'production') {
    // console.log(`trackModal ${modalConfig} - blocked in dev`);
    return;
  }
  const { screens } = window.__DATA__;
  if (!screens || !modalConfig || !payload) return;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const modal = getCurrentModal(screens, modalConfig);
  if (!modal) return;
  if (window.trackModal) {
    window.trackModal(modal, { ...store, item: payload, params });
  }
}

const isTarteAuCitronAnalyticsCookieEnable = () => {
  const tarteAuCitronCookieName = window.__DATA__?.cookieName || 'tarteaucitron';
  const cookieValue = Cookies.get(tarteAuCitronCookieName);
  if (!cookieValue) {
    return false;
  }
  const isMatch = /analytics=([^!]*).*/.exec(cookieValue)[1] === 'true';
  return isMatch;
};

export function trackPage(locationPath, screens) {
  const currentRgpdRules = store.storage.getRgpdRules();
  if (window.ga && isTarteAuCitronAnalyticsCookieEnable()) {
    window.ga('set', 'page', locationPath);
    window.ga('send', 'pageview');
  }

  if (currentRgpdRules?.status === 'refuse') {
    // console.log(`trackPage ${locationPath} - blocked by rgpd policy`);
    return;
  }
  if (process.env.NODE_ENV !== 'production') {
    // console.log(`trackPage ${locationPath} - blocked in dev`);
    return;
  }
  const stats = window.__DATA__?.screens?.stats || {};
  const { trackPages = true } = stats;

  const isUserConnected = store?.user?._id;
  if (!isUserConnected) return;
  // Default appcraft events tracking, no await needed
  if (trackPages) {
    platformService.stats('VIEW_PAGE', {
      path: locationPath,
      url: window.location.href,
    });
  }

  const page = getCurrentPage(screens, locationPath);
  if (window.trackPage) {
    window.trackPage(page, { ...store, item: { slug: splitPath(locationPath)?.sub } });
  }
  if (!page) return; // Not sure what to track...

  if (window.__DATA__?.tagCommander?.trackPages) {
    tcTrackPage(locationPath, page);
  }
}
